import { Link } from 'react-router-dom';

interface GuideItem {
  title: string;
  subtitle: string;
  linkTo: string;
  isExternal?: boolean;
  externalUrl?: string;
}

interface FeatureGridProps {
  title: string;
  items: GuideItem[];
  imageUrls: string[];
}

export default function FeatureGrid({ title, items, imageUrls }: FeatureGridProps) {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-2">
            {title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => {
            const content = (
              <div className="group relative w-full aspect-square rounded-2xl overflow-hidden cursor-pointer">
                <img
                  src={imageUrls[i] || ''}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
                  <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-white/80 leading-relaxed">
                    {item.subtitle}
                  </p>
                </div>
              </div>
            );

            if (item.isExternal && item.externalUrl) {
              return (
                <a key={i} href={item.externalUrl} target="_blank" rel="noopener nofollow">
                  {content}
                </a>
              );
            }

            return (
              <Link key={i} to={item.linkTo}>
                {content}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}